// extracted by mini-css-extract-plugin
module.exports = {"line":"SkeletonLine_line__1r5pa","picto":"SkeletonLine_picto__3utQu","text":"SkeletonLine_text__KlTrS"};